// eslint-disable-next-line no-unused-expressions
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { isEmpty } from 'AccountsUtils'
import { DOMAIN, path } from '../../utils/common'
import { apiGetHelper } from '../../utils/nav-http-cookie'

export const personalization = localStorageDeviceId => {
  try {
    const URL = `${DOMAIN}/personalization` // add domain and same in proxy file

    const paramsCheckAndroidOrIos = new Proxy(new URLSearchParams(path(['location', 'search'], window)), {
      get: (searchParams, prop) => searchParams.get(prop)
    })
    const deviceType = paramsCheckAndroidOrIos?.isAndroidApp === 'true' ? 'AndroidApp' : paramsCheckAndroidOrIos?.isIosApp === 'true' ? 'iPhoneApp' : 'pwa'
    if (deviceType === 'AndroidApp') {
      window.androidData = JSON.parse(window.MobileApp.getAppSpecificData())
    }

    const params = window?.location?.href
    const isPWA = params.indexOf('/m/support') !== -1
    const response = apiGetHelper(URL, isPWA, 'application/json', { caller: `${window.location.host}`,
      ...(localStorageDeviceId && { dvid: localStorageDeviceId }),
      ...(window && !isEmpty(window?.androidData?.device_id) && { dvid: window?.androidData?.device_id }),
      ...(window && !isEmpty(window?.iosData?.device_id) && { dvid: window?.iosData?.device_id }) })
    return response
  } catch (e) {
    console.error(e)
  }
}
